'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _centerControl = require('./center-control');

var _centerControl2 = _interopRequireDefault(_centerControl);

var _controlBar = require('./control-bar');

var _controlBar2 = _interopRequireDefault(_controlBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controls = function () {
  function Controls(elVideo, options) {
    _classCallCheck(this, Controls);

    this.elVideo = elVideo;
    this.options = options || {};

    if (this.options.showCenterControl !== 'none') {
      this.centerControl = new _centerControl2['default'](elVideo, this.options);
    }
    if (this.options.showControlBar !== 'none') {
      this.barControl = new _controlBar2['default'](elVideo, this.options);
    }

    this.bindEvents();
  }

  Controls.prototype.bindEvents = function bindEvents() {
    var _this = this;

    this.elVideo.addEventListener('ended', function () {
      // ie在ended后不会触发pause事件，这里手动执行一下
      _this.elVideo.pause();
    });

    /*
     * 在播放完成后reload视频，展示默认封面信息
     * 注意在pause后再reload，否则IE会异常无法播放
     */
    this.options.reload && this.elVideo.addEventListener('pause', function () {
      if (!_this.elVideo.ended) {
        return;
      }
      _this.elVideo.load();
    });
  };

  Controls.prototype.destroy = function destroy() {
    this.barControl && this.barControl.destroy();
  };

  return Controls;
}();

exports['default'] = Controls;
module.exports = exports['default'];